export default "__VITE_ASSET__BqgQH4t8__"